(() => {
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  const shuffle = (arr) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const ensureMediaLoaded = (card) => {
    const skeleton = card.querySelector(".hm-tiktok__skeleton");

    const video = card.querySelector("video[data-src]");
    if (video) {
      if (!video.src) {
        video.src = video.dataset.src;
        video.removeAttribute("data-src");
        try {
          video.load();
        } catch (_) {
          // ignore
        }
      }
      if (skeleton) skeleton.remove();
      return;
    }

    const iframe = card.querySelector("iframe[data-src]");
    if (!iframe) return;
    if (iframe.src) return;
    iframe.src = iframe.dataset.src;
    iframe.removeAttribute("data-src");
    if (skeleton) skeleton.remove();
  };

  const initCarousel = (root) => {
    const track = root.querySelector("[data-hm-tiktok-track]");
    if (!track) return;

    const cards = qsa(track, "[data-hm-tiktok-card]");
    const limit = Math.max(0, parseInt(root.dataset.limit || "0", 10));
    const randomize = (root.dataset.randomize || "true") !== "false";

    if (randomize && cards.length > 1) {
      const shuffled = shuffle(cards.slice());
      shuffled.forEach((c) => track.appendChild(c));
    }

    if (limit && cards.length) {
      qsa(track, "[data-hm-tiktok-card]").forEach((card, idx) => {
        card.hidden = idx >= limit;
      });
    }

    // Lazy-load embeds
    const io = "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              ensureMediaLoaded(e.target);
              io.unobserve(e.target);
            });
          },
          { root: track, threshold: 0.2 }
        )
      : null;

    qsa(track, "[data-hm-tiktok-card]").forEach((card, idx) => {
      if (idx < 2) ensureMediaLoaded(card);
      else if (io) io.observe(card);
      else ensureMediaLoaded(card);
    });

    const scrollByCard = (dir) => {
      const visible = qsa(track, "[data-hm-tiktok-card]").find((c) => !c.hidden);
      if (!visible) return;
      const gap = parseFloat(getComputedStyle(track).gap || "16") || 16;
      const cardWidth = visible.getBoundingClientRect().width;
      track.scrollBy({ left: dir * (cardWidth + gap), behavior: "smooth" });
    };

    const prev = root.querySelector("[data-hm-tiktok-prev]");
    const next = root.querySelector("[data-hm-tiktok-next]");
    if (prev) prev.addEventListener("click", () => scrollByCard(-1));
    if (next) next.addEventListener("click", () => scrollByCard(1));
  };

  const initWall = (root) => {
    // Social wall uses the same lazy loading pattern; optionally randomizes order.
    const grid = root.querySelector("[data-hm-social-wall-grid]") || root;
    const randomize = (root.dataset.randomize || "true") !== "false";
    let cards = qsa(grid, "[data-hm-tiktok-card]");

    if (randomize && cards.length > 1) {
      const shuffled = shuffle(cards.slice());
      shuffled.forEach((c) => grid.appendChild(c));
      cards = qsa(grid, "[data-hm-tiktok-card]");
    }

    const io = "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (!e.isIntersecting) return;
              ensureMediaLoaded(e.target);
              io.unobserve(e.target);
            });
          },
          { threshold: 0.15 }
        )
      : null;

    cards.forEach((card, idx) => {
      if (idx < 3) ensureMediaLoaded(card);
      else if (io) io.observe(card);
      else ensureMediaLoaded(card);
    });
  };

  const boot = () => {
    qsa(document, "[data-hm-tiktok-carousel]").forEach(initCarousel);
    qsa(document, "[data-hm-social-wall]").forEach(initWall);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();


